import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

'use strict';
/***
 * A sample AJAX data store implementation to load data from the search views.
 */
function RemoteSearchDataView(search_url, model, modelAccessor, columns, viewModel) {
        // private
        var pagesize = 50;
        var pagenum = 0;
        var data = {
                length: 0, 
        };
        var public_data = {
                getLength: function() { return data.length; },
                getItemMetadata: getItemMetadata,
                getItem: getItem
        };
        var inited = false;
        var searchstr = null;
        var sortcol = null;
        var sortdir = 1;
        var h_request = null;
        var req = null; // ajax request
        var _req_deferred = Promise.Deferred();
        var filters = {}; //filter for search.

        // events
        var onDataLoading = new Slick.Event();
        var onDataLoaded = new Slick.Event();
        var onPagingInfoChanged = new Slick.Event();
        var onDataRefreshed = new Slick.Event();
        var onRowsChanged = new Slick.Event();
        var onRowCountChanged = new Slick.Event();
        var onGetItemMetadata = new Slick.Event();
        
        function init() {
                $.each(columns, function(idx, column) {
                        if (column.sorted) {
                                sortcol = column;
                                sortdir = column.sort_direction == "asc" ? 1 : 0;
                        }
                });
                var livemodel = ko.utils.unwrapObservable(modelAccessor());
                var _filter_obs = ko.pureComputed(function() {
                        var filters = ko.toJS(livemodel.filters);
                        return filters;
                });
                _filter_obs.subscribe(function(newvalue) {
                        refresh();
                });
        }


        function isDataLoaded(from, to) {
                if (data.length > 0 && to > data.length)
                        to = data.length;
                for (var i = from; i < to; i++) {
                        if (typeof data[i] == "undefined" || data[i] == null) {
                                return false;
                        }
                }
                
                return true;
        }


        function clear() {
                for (var key in data) {
                        delete data[key];
                }
                data.length = 0;
        }

        function refresh() {
                var countBefore = data.length;
                var totalRowsBefore = data.length;
                clear();
                onDataRefreshed.notify({});
        }

        function getFilters(model_var) {
                var filters = ko.utils.unwrapObservable(model_var);
                if (filters != null) {
                        if (Object.isObject(filters)) {
                                var tmpf = {};
                                $.each(filters, function(key,value) {
                                        if (value != null && value != "" && (key.indexOf("__")!=0 || key.indexOf("__f") == 0))
                                                tmpf[key] = value;
                                });
                                filters = ko.toJSON(tmpf);
                        }
                        else if (Array.isArray(filters))
                                return filters;
                        
                        return filters;
                }
        }

        
        function getPostData() {
                var pd = {};
                var origin = ko.utils.unwrapObservable(model.origin);
                if (!origin) {
                        var entity = ko.utils.unwrapObservable(model.entity);
                        var id = ko.utils.unwrapObservable(viewModel._currentEntityId);
                        if (!id)
                                id = ko.utils.unwrapObservable(viewModel.id);
                        else {
                                origin = id;
                                entity = null;
                        }
                        if (entity && !id) {
                                if (ko.utils.unwrapObservable(viewModel.viewdata)) {
                                        id = ko.utils.unwrapObservable(ko.utils.unwrapObservable(viewModel.viewdata).id);
                                }
                        }
                        if (entity && id) {
                                origin = entity + "#" + id;
                        }
                }
                if (origin)
                        pd["origin"] = origin;
                pd["path"] = ko.utils.unwrapObservable(model.path);
            if (typeof model.require_fields != "undefined" && model.require_fields) {
                pd["require_fields"] = ko.toJS(model.require_fields);
            }
                if (typeof model.filters != "undefined" || (typeof model.extra_filters != "undefined")) {
                        pd["f"] = ko.pureComputed(function() {
                                var current_model = ko.utils.unwrapObservable(modelAccessor());
                                if (typeof current_model != "undefined" && current_model != null) {
                                        var f1 = getFilters(current_model.filters);
                                        var f2 = getFilters(current_model.extra_filters);
                                        if (Array.isArray(f1) && Array.isArray(f2)) {
                                                return f1.concat(f2);
                                        }
                                        else if (f1 && f2) return ([f1,f2]);
                                        else if (f1) return f1;
                                        else if (f2) return f2;
                                        else return null;
                                }
                                return "";
                        })();
                }
                var view = ko.utils.unwrapObservable(model.view);
                if (view) 
                        pd["view"] = view;
                if (sortcol) {
                        if (Object.isObject(sortcol)) {
                                pd["sidx"] = sortcol.field;
                        }
                        else pd["sidx"] = sortcol;
                }
                pd["sord"] = sortdir>0 ? "asc":"desc";
                if (h_request != null) {
                        clearTimeout(h_request);
                }
                var search_filters = [];
                $.each(filters, function(key, val) {
                        var op = val[0], v = val[1];
                        if (op) {
                            if (v && typeof v == "string") {
                                v = v.replace("%", "%25")
                            }
                            search_filters.push(key+op+ko.toJSON(v));
                        }
                });
                if (search_filters.length > 0) {
                        if (search_filters.length == 1)
                                pd["filters"] = search_filters[0];
                        else pd["filters"] = search_filters;
                }
            var distinct = ko.utils.unwrapObservable(model.distinct);
            if (distinct)
                pd["distinct"] = true;

            return { "postdata":{"__json":ko.toJSON(ko.toJS(pd))}, "url":search_url };
        }
        function ensureData(from, to) {
                var _deferred = null;
                if (req) {
                        req.abort();
                        data[req.fromFetch] = undefined;
                        if (req.fromFetch < from)
                                from = req.fromFetch;
                        if (req.toFetch > to)
                                to = req.toFetch;
                        _deferred = _req_deferred;
                        
                }
                if (null == _deferred) {
                        if (_req_deferred) {
                                _req_deferred.reject("abort");
                        }
                        _deferred = _req_deferred = Promise.Deferred();
                }

                if (from < 0) {
                        from = 0;
                }

                var fromFetch= from;
                var toFetch = to;
                while(data[fromFetch] !== undefined && fromFetch <= toFetch)
                        fromFetch++;
                while(data[toFetch] !== undefined && fromFetch <= toFetch)
                        toFetch --;
                if (fromFetch > toFetch || ((fromFetch == toFetch) && isDataLoaded(fromFetch, fromFetch+pagesize))) {
                        _req_deferred.resolve([fromFetch,toFetch]);
                        return _req_deferred;
                }
                var postdata = getPostData();
                var pd = postdata.postdata;
                var url = postdata.url;
                pd["offset"] = fromFetch;
                pd["count"] = (toFetch-fromFetch)+pagesize;

                h_request = setTimeout(function () {
                        for (var i = fromFetch; i <= toFetch; i++)
                                data[i] = null; // null indicates a 'requested but not available yet'

                        onDataLoading.notify({from: from, to: to});

                        req = $.ajax({
                                url: url,
                                type:"POST",
                                data:pd,
                                success: function(resp) { return onSuccess(fromFetch, resp, columns); },
                                error: function () {
                                        onError(fromFetch, toFetch)
                                }
                        });
                        req.fromFetch = fromFetch;
                        req.toFetch = toFetch;
                }, 50);
                return _req_deferred;
        }


        function onError(fromFetch, toFetch) {
                console.log("got error loading rows:", fromFetch, toFetch);
                if (null != _req_deferred) 
                        _req_deferred.reject([fromFetch, toFetch]);
        }
        
        function onSuccess(fromRow, resp, columns) {
            if (resp && resp.viewdata) {
                resp = resp.viewdata;
            }
            if (!resp) {
                resp = { rows:[] };
            }
                var from = fromRow, to = from + resp.rows.length;
                var old_length = data.length;
                data.length = parseInt(resp.records);
                var diff = Array(resp.rows.length);
                for (var i = 0; i < resp.rows.length; i++) {
                        var net_row = resp.rows[i];
                        //need row in correct format here...
                        var row = $.extend(net_row, { "id":net_row[model.idfield] });
                        if (net_row.__link)
                                row["__link"] = net_row.__link;
                        $.each(columns, function(idx, column) {
                                if (typeof net_row[column.field] == "undefined" && column.field.indexOf(".") >= 0) {
                                        var toks = column.field.split(".");
                                        var cval = net_row;
                                        $.each(toks, function(idx,tok) {
                                                if (tok && typeof cval != "undefined" && cval != null) {
                                                        cval = cval[tok];
                                                }
                                        });
                                        row[column.field] = cval;
                                }
                                else {
                                        var cval = net_row[column.field];
                                        if (cval && typeof cval.replace == "function")
                                                cval = cval.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
                                        row[column.field] = cval;
                                }
                        });
                        data[from + i] = row;
                        data[from + i].index = from + i;
                        diff[i] =  from+i;
                }

                req = null;
                onDataLoaded.notify({from: from, to: to});
                onPagingInfoChanged.notify(getPagingInfo(), null, self);
                if (data.length != old_length)
                        onRowCountChanged.notify({ previous:old_length, current:data.length}, null, self);
                onRowsChanged.notify({rows:diff},null,self);
                if (null != _req_deferred) 
                        _req_deferred.resolve([from, to]);
                inited = true

        }


        function reloadData(from, to) {
                for (var i = from; i <= to; i++)
                        delete data[i];

                ensureData(from, to);
        }


        function setSort(column, dir) {
                sortcol = column;
                sortdir = dir;
                refresh();
        }

        function setSearch(field,op,val) {
                if (field) {
                        if (!op || op == "" ||  (val === "") )
                                delete(filters[field]);
                        else filters[field] = [op, val];
                }
                if(inited)
                    refresh();
        }

        function setPagingOptions(args) {
                var totalRows = data.length;
                if (args.pageSize != undefined) {
                        pagesize = args.pageSize;
                        pagenum = pagesize ? Math.min(pagenum, Math.max(0, Math.ceil(totalRows / pagesize) - 1)) : 0;
                }

                if (args.pageNum != undefined) {
                        pagenum = Math.min(args.pageNum, Math.max(0, Math.ceil(totalRows / pagesize) - 1));
                }

                onPagingInfoChanged.notify(getPagingInfo(), null, self);

                refresh();
        }

        function getPagingInfo() {
                var totalRows = data.length;
                var totalPages = pagesize ? Math.max(1, Math.ceil(totalRows / pagesize)) : 1;
                return { pageSize: pagesize, pageNum: pagenum, totalRows: totalRows, totalPages: totalPages};
        }

        function getItem(row) {
                return data[row];
        }
    
    function isReady() {
        return inited;
    }

    var row_styler = null;
    if (ko.utils.unwrapObservable(model.row_style)) {
        row_styler = Crimson.clientscripts["_"+ko.utils.unwrapObservable(model.row_style)];
    }
        function getItemMetadata(row) {
            var classes = null;
            if (row_styler)
                classes = row_styler(row, this.getItem(row));
            var args = { "row":row, "metadata":{ "cssClasses":classes} };
            onGetItemMetadata.notify(args);
            return args.metadata;
        }
        init();

        return {
                // properties
                "data": public_data,

                // methods
                "clear": clear,
                "refresh": refresh,
                "isDataLoaded": isDataLoaded,
                "ensureData": ensureData,
                "reloadData": reloadData,
                "setSort": setSort,
                "setSearch": setSearch,
                "setPagingOptions": setPagingOptions,
                "getPagingInfo": getPagingInfo,
                "getPostData": getPostData,
                //data provider method
                "getItem":getItem,
                //events
                "onDataLoading": onDataLoading,
                "onDataLoaded": onDataLoaded,
                "onPagingInfoChanged": onPagingInfoChanged,
                "onDataRefreshed": onDataRefreshed,
                "onRowCountChanged": onRowCountChanged,
                "onRowsChanged": onRowsChanged,
                //"onPagingInfoChanged": onPagingInfoChanged,
            "onGetItemMetadata": onGetItemMetadata,
            "isReady":isReady
        };
}

// Crimson.ui.grid.RemoteSearchDataView
$.extend(true, Crimson, { ui: { grid: { RemoteSearchDataView: RemoteSearchDataView }}});
